import { Check, MoreHoriz } from '@mui/icons-material'
import { CircularProgress } from '@mui/material'

import CustomTypography from '@/components/dataDisplay/CustomTypography'

interface ConfigurationStatusIndicatorProps {
  inProgress?: boolean
  message: string
  success?: boolean
}

export function ConfigurationStatusIndicator({
  inProgress,
  message,
  success,
}: Readonly<ConfigurationStatusIndicatorProps>) {
  if (inProgress) {
    return (
      <>
        <CircularProgress />
        <CustomTypography>{message}</CustomTypography>
      </>
    )
  } else if (success) {
    return (
      <>
        <Check color="success" />
        <CustomTypography color="success">{message}</CustomTypography>
      </>
    )
  } else {
    return (
      <>
        <MoreHoriz color="info" />
        <CustomTypography color="info">{message}</CustomTypography>
      </>
    )
  }
}
